const LocalConfig = {
    whatsappURL: "https://wa.me/555481702266"
}

export default LocalConfig;